import React from 'react';
import { Intent } from 'constants/ui';
import BaseHint from '../BaseHint';
const NoItemDetectedHint = ({ itemKindInformalText }) => (React.createElement(BaseHint, { intent: Intent.DANGER, multiline: true, text: `Please update your file to include at least one ${itemKindInformalText} and upload it again.`, title: `No ${itemKindInformalText}s were detected in your file` }));
export default NoItemDetectedHint;
